import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import './RustTest.css';

const MODULE_SELECTORS = [
  '.tv-stours.tv-moduleid-9995381',
  '.tv-country.tv-moduleid-9995404',
  '.tv-calendar.tv-moduleid-9995376',
  '.tv-history.tv-moduleid-9995406',
  '.tv-hot-tours.tv-moduleid-9995421',
  '.tv-calendar.tv-moduleid-9995422',
  '.tv-country.tv-moduleid-9995377',
];

const runTourvisorInit = () => {
  try {
    if (typeof window.TV?.loadModules === 'function') {
      window.TV.loadModules();
      return;
    }
    if (typeof window.TV?.init === 'function') window.TV.init();
    if (typeof window.Tv?.init === 'function') window.Tv.init();
    if (typeof window.tourvisorInit === 'function') window.tourvisorInit();
  } catch (err) {
    console.warn('Tourvisor rusttest init error:', err);
  }
};

const unlockEmptyModules = () => {
  MODULE_SELECTORS.forEach((selector) => {
    const el = document.querySelector(selector);
    if (el && el.childElementCount === 0) el.classList.remove('tv-loaded');
  });
};

const RustTest = () => {
  const [mountKey] = useState(() => Date.now());

  useEffect(() => {
    let cancelled = false;
    const timers = [];
    let started = false;

    const start = () => {
      if (cancelled || started) return;
      started = true;
      unlockEmptyModules();
      runTourvisorInit();
      // Повтор только для пустых блоков, без очистки innerHTML (иначе ломаем async-init Tourvisor)
      [1000, 2500, 5000].forEach((delay) => {
        timers.push(
          window.setTimeout(() => {
            if (cancelled) return;
            unlockEmptyModules();
            runTourvisorInit();
          }, delay)
        );
      });
    };

    if (window.TV?.loadModules || window.TV?.init) {
      // Дать React дорисовать контейнеры
      timers.push(window.setTimeout(start, 0));
    } else {
      const waitId = window.setInterval(() => {
        if (window.TV?.loadModules || window.TV?.init) {
          window.clearInterval(waitId);
          start();
        }
      }, 100);
      timers.push(waitId);
      timers.push(
        window.setTimeout(() => {
          window.clearInterval(waitId);
          if (!started) start();
        }, 8000)
      );
    }

    return () => {
      cancelled = true;
      timers.forEach((id) => {
        window.clearTimeout(id);
        window.clearInterval(id);
      });
    };
  }, [mountKey]);

  return (
    <>
      <Header />
      <main className="rusttest-page">
        <div className="rusttest-container" key={mountKey}>
          <section className="rusttest-widget">
            <div className="tv-stours tv-moduleid-9995381" />
          </section>
          <section className="rusttest-widget">
            <div className="tv-country tv-moduleid-9995404" />
          </section>
          <section className="rusttest-widget">
            <div className="tv-calendar tv-moduleid-9995376" />
          </section>
          <section className="rusttest-widget">
            <div className="tv-history tv-moduleid-9995406" />
          </section>
          <section className="rusttest-widget">
            <div className="tv-hot-tours tv-moduleid-9995421" />
          </section>
          <section className="rusttest-widget">
            <div className="tv-calendar tv-moduleid-9995422" />
          </section>
          <section className="rusttest-widget">
            <div className="tv-country tv-moduleid-9995377" />
          </section>
        </div>
      </main>
    </>
  );
};

export default RustTest;
